import React from 'react'
import { SVGProps } from 'react'

const NotificationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.2528 11.2753C13.2448 10.4233 12.6668 9.178 12.6668 7.85867V6C12.6668 3.654 10.9242 1.712 8.66683 1.38667V0.666667C8.66683 0.298 8.36816 0 8.00016 0C7.63216 0 7.3335 0.298 7.3335 0.666667V1.38667C5.0755 1.712 3.3335 3.654 3.3335 6V7.85867C3.3335 9.178 2.7555 10.4233 1.7415 11.2807C1.48216 11.5027 1.3335 11.8253 1.3335 12.1667C1.3335 12.81 1.85683 13.3333 2.50016 13.3333H13.5002C14.1435 13.3333 14.6668 12.81 14.6668 12.1667C14.6668 11.8253 14.5182 11.5027 14.2528 11.2753Z" />
    <path d="M8.00011 16C9.20745 16 10.2174 15.1393 10.4494 14H5.55078C5.78278 15.1393 6.79278 16 8.00011 16Z" />
  </svg>
)
export default NotificationIcon
